import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { MenuItem } from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import Button from "@mui/material/Button";
import Sidebar from "../../../Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import "../AddLoan.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../../App";
import Cookies from 'js-cookie';
import TrancheDock from "../Tranches/TrancheDock";
import Tooltip from '@mui/material/Tooltip';

export default function EditLoan() {
  const [open, setOpen] = React.useState(false);
  const email = Cookies.get('Email');
  const token = Cookies.get('Token');
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [loanProduct, setLoanProduct] = useState("");
  const [showLifeIns, setShowLifeIns] = useState("");
  const [showPropertyIns, setShowPropertyIns] = useState("");
  const [showCattleIns, setShowCattleIns] = useState("");
  const [loanfeesArray, setloanfeesArray] = useState([]);
  const [loanEmiAmount, setLoanEmiAmount] = useState("");
  const [lifeInsuranceTitle, setlifeInsuranceTitle] = useState("");
  const [propertyInsuranceTitle, setpropertyInsuranceTitle] = useState("");
  const [cattleInsuranceTitle, setCattleInsuranceTitle] = useState("");
  const [lifeInsuranceAmount, setlifeInsuranceAmount] = useState("0");
  const [cattleInsuranceAmount, setcattleInsuranceAmount] = useState("0");
  const [propertyInsuranceAmount, setpropertyInsuranceAmount] = useState("0");
  const [aprIrr, setaprIrr] = useState("");
  const [insurancetypeData, setinsurancetypeData] = useState("topup_amt");
  const [loanProductInterestRate, setLoanProductInterestRate] = useState("");
  const [loanPrincipalAmount, setLoanPrincipalAmount] = useState("");
  const [advanceEmi, setAdvanceEmi] = useState(0);
  const [numberOfTranche, setNumberOfTranche] = useState("1");
  const [currentTrancheNumber, setCurrentTrancheNumber] = useState()
  const [selectGuarantors, setSelectGuarantors] = useState("");
  const [selectBorrower, setSelectBorrower] = useState("");
  const [loanReleaseDate, setLoanReleaseDate] = useState("");
  const [loanEmiStartDate, setLoanEmiStartDate] = useState("");
  const [loanEmiLastDate, setLoanEmiLastDate] = useState("");
  const [loanTenureStartDate, setLoanTenureStartDate] = useState("");
  const [loanPreEmiInterest, setLoanPreEmiInterest] = useState("");
  const [loanDuration, setLoanDuration] = useState("");
  const [pfWaiver, setpfWaiver] = useState("");
  const [pfAmount, setpfAmount] = useState("");
  const [netPf, setNetPf] = useState("");
  const [loanDisbursedAmount, setLoanDisbursedAmount] = useState("");
  const [totalOutstandingAmount, setTotalOutstandingAmount] = useState("");
  const [pendingPrincipal, setpendingPrincipal] = useState("");
  const [pendingInterest, setpendingInterest] = useState("");
  const [pendingCharges, setpendingCharges] = useState("");
  const [waiver, setWaiver] = useState(0);
  const [netOutstandingAmount, setNetOutstandingAmount] = useState("");
  const [loanDisbursedAmtCus, setloanDisbursedAmtCus] = useState("");
  const [topUpAmount, settopUpAmount] = useState("");
  const [chargesWaiver, setchargesWaiver] = useState("");
  const [interestWaiver, setinterestWaiver] = useState("");
  const [loanComments, setLoanComments] = useState("");
  const [loanId, setLoanId] = useState("");
  const [data2, setData2] = useState([]);
  // const [loanFeeArray, setLoanFeeArray] = useState([]);
  const [numberOfCow, setNumberOfCow] = useState(0);
  const [numberOfBuffalo, setNumberOfBuffalo] = useState(0);
  const [loanProductGroupDairy, setLoanProductGroupDairy] = useState(false);
  const [isDropdownDisabled, setDropdownDisabled] = useState(false);
  const [autoComputeLoanAmount, setAutoComputeLoanAmount] = useState(false);
  const [trancheArray, setTrancheArray] = useState([])
  const [currentTrancheArr, setCurrentTrancheArr] = useState([])
  const [loanType, setLoanType] = useState("");
  const [dropdownLoanObj, setDropdownLoanObj] = useState({
    loanCount: 0,
    repeatCheck: true,
    topupCheck: true,
    topupbtCheck: true,
    restructureCheck: true,
    checkNew: true
  });
  const [partlyDisbursed, setPartlyDisbursed] = useState(false)
  const [loanPurpose, setLoanPurpose] = useState("");
  const [isFirstCalculateClicked, setIsFirstCalculateClicked] = useState(false);
  const [isSecondCalculateClicked, setIsSecondCalculateClicked] = useState(true);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [priceOfCow, setPriceOfCow] = useState("");
  const [priceOfBuffalo, setPriceOfBuffalo] = useState("");
  const [cattleInsuranceTenure, setcattleInsuranceTenure] = useState("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const [repaymentArray, setRepaymentArray] = useState([]);
  const [isDisbursed, setIsDisbursed] = useState(false);
  const [isLIInternal, setIsLIInternal] = useState(false);

  useEffect(() => {
    let total = parseInt(totalOutstandingAmount) || 0;
    let w = parseInt(waiver) || 0;

    let net_os = w === 0 ? total : total - w;

    setNetOutstandingAmount(net_os);
  }, [totalOutstandingAmount, waiver]);

  useEffect(() => {
    let total = parseInt(pfAmount) || 0;
    let w = parseInt(pfWaiver) || 0;

    let net_pf = w === 0 ? total : total - w;

    setNetPf(net_pf);
  }, [pfAmount, pfWaiver]);

  const handleUpdateCharges = () => {
    setIsFirstCalculateClicked(false);
    if (loanType === "TOPUP" || loanType === "TOPUP + BT") {
      axios
        .post(url + "/loan/topup/typechange", {
          token: token,
          email: email,
          borrower_uniqueno: selectBorrower,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.auth === false) {
            toast.error(res.data.message);
          } else {
            toast.success("Latest outstanding amount fetched successfully.")
            setTotalOutstandingAmount(res.data.message?.total_outstanding);
            setpendingPrincipal(res.data.message?.pendingPrincipal);
            setpendingInterest(res.data.message?.pendingInterest);
            setpendingCharges(res.data.message?.pendingCharges);
          }
        });
    }
  };


  const handleChangeLoanProduct = (event) => {
    setLoanProduct(event.target.value);
    setIsFirstCalculateClicked(false);
    // console.log(event.target.value);
    axios
      .post(url + "/loanproduct/getsingle", {
        token: token,
        email: email,
        loanproduct_id: event.target.value,
      })
      .then((res) => {
        if (res.data[0].loanproduct_group === 'DAIRY LOAN') {
          setLoanProductGroupDairy(true)
        } else {
          setLoanProductGroupDairy(false)
        }
        setIsLIInternal(res.data[0].loanproduct_life_ins?.loanproduct_insurance === "INTERNAL")
        setShowLifeIns(
          res.data[0].loanproduct_life_ins.life_ins
            ? res.data[0].loanproduct_life_ins.life_ins
            : ""
        );
        setShowPropertyIns(
          res.data[0].loanproduct_property_ins
            ? res.data[0].loanproduct_property_ins.property_ins
            : ""
        );
        setShowCattleIns(
          res.data[0].loanproduct_cattle_ins
            ? res.data[0].loanproduct_cattle_ins.cattle_ins
            : ""
        );
        setlifeInsuranceTitle(
          res.data[0].loanproduct_life_ins.loanproduct_insurance
            ? res.data[0].loanproduct_life_ins.loanproduct_insurance
            : ""
        );
        setpropertyInsuranceTitle(
          res.data[0].loanproduct_property_ins
            ? res.data[0].loanproduct_property_ins.loanproduct_insurance
            : ""
        );
        setCattleInsuranceTitle(
          res.data[0].loanproduct_cattle_ins
            ? res.data[0].loanproduct_cattle_ins.loanproduct_insurance
            : ""
        );
        // setLoanFeeArray(
        //   res.data[0].loanfees_id ? res.data[0].loanfees_id : ""
        // );
        setloanfeesArray(res.data[0].loanfees_id ? res.data[0].loanfees_id : "");
        setAutoComputeLoanAmount(
          res.data[0].autoComputeLoanAmount ? res.data[0].autoComputeLoanAmount : false
        )
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const handleChangeLoanProductInterestRate = (event) => {
  //   setLoanProductInterestRate(event.target.value);
  //   if (loanType === "TOPUP") {
  //     if (
  //       event.target.value !== "" &&
  //       loanDuration !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topup/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: event.target.value,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }

  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProduct !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: event.target.value,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           // console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "TOPUP + BT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanDuration !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topupbt/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: event.target.value,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  // };

  // const handleTenureStartDate = (event) => {
  //   setLoanTenureStartDate(event.target.value);
  //   if (loanType === "TOPUP") {
  //     if (
  //       event.target.value !== "" &&
  //       loanDuration !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topup/calculate", {
  //           token: token,
  //           email: email,
  //           loan_tenure_start_date: event.target.value,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }

  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProduct !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           loan_tenure_start_date: event.target.value,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           // console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "TOPUP + BT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanDuration !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topupbt/calculate", {
  //           token: token,
  //           email: email,
  //           loan_tenure_start_date: event.target.value,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  // };

  // const handlelifeInsuranceAmount = (event) => {
  //   setlifeInsuranceAmount(event.target.value);
  //   if (loanType === "TOPUP") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       loanReleaseDate !== "" &&
  //       topUpAmount !== "" &&
  //       insurancetypeData !== "" &&
  //       propertyInsuranceAmount !== ""
  //     )
  //       setOpen(true);
  //     axios
  //       .post(url + "/loan/topup/calculate", {
  //         token: token,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_tenure_start_date: loanTenureStartDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: event.target.value,
  //         loan_property_ins: propertyInsuranceAmount,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: insurancetypeData,
  //         loan_topup_amt: topUpAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         toast.error(err);
  //       });
  //   }

  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProduct !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       propertyInsuranceAmount !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: event.target.value,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           // console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             // console.log(res.data);
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           // console.log(err);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "TOPUP + BT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       loanReleaseDate !== "" &&
  //       topUpAmount !== "" &&
  //       insurancetypeData !== "" &&
  //       propertyInsuranceAmount !== ""
  //     )
  //       setOpen(true);
  //     axios
  //       .post(url + "/loan/topupbt/calculate", {
  //         token: token,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_tenure_start_date: loanTenureStartDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: event.target.value,
  //         loan_property_ins: propertyInsuranceAmount,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: insurancetypeData,
  //         loan_topup_amt: topUpAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         toast.error(err);
  //       });
  //   }
  // };

  // const handlepropertyInsuranceAmount = (event) => {
  //   setpropertyInsuranceAmount(event.target.value);
  //   if (loanType === "TOPUP") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanDuration !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       insurancetypeData !== "" &&
  //       lifeInsuranceAmount !== ""
  //     )
  //       setOpen(true);
  //     axios
  //       .post(url + "/loan/topup/calculate", {
  //         token: token,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_tenure_start_date: loanTenureStartDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: lifeInsuranceAmount,
  //         loan_property_ins: event.target.value,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: insurancetypeData,
  //         loan_topup_amt: topUpAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         toast.error(err);
  //       });
  //   }

  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProduct !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: event.target.value,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           // console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             // console.log(res.data);
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           // console.log(err);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "TOPUP + BT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanDuration !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       insurancetypeData !== "" &&
  //       lifeInsuranceAmount !== ""
  //     )
  //       setOpen(true);
  //     axios
  //       .post(url + "/loan/topupbt/calculate", {
  //         token: token,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_tenure_start_date: loanTenureStartDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: lifeInsuranceAmount,
  //         loan_property_ins: event.target.value,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: insurancetypeData,
  //         loan_topup_amt: topUpAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         toast.error(err);
  //       });
  //   }
  // };

  // const handleChangeLoanPrincipalAmount = (event) => {
  //   setLoanPrincipalAmount(event.target.value);
  //   if (
  //     loanProduct !== "" &&
  //     loanProductInterestRate !== "" &&
  //     loanReleaseDate !== "" &&
  //     loanDuration !== "" &&
  //     pfWaiver !== "" &&
  //     lifeInsuranceAmount !== "" &&
  //     propertyInsuranceAmount !== ""
  //   ) {
  //     setOpen(true);
  //     axios
  //       .post(url + "/loan/calculate", {
  //         token: token,
  //         email: email,
  //         loan_tenure_start_date: loanTenureStartDate,
  //         loan_release_date: loanReleaseDate,
  //         loan_duration: loanDuration,
  //         loan_principal_amt: event.target.value === "" ? 0 : event.target.value,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         pf_waiver: pfWaiver,
  //         loan_life_ins: lifeInsuranceAmount,
  //         loan_property_ins: propertyInsuranceAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo,
  //         trancheArray: trancheArray
  //       })
  //       .then((res) => {
  //         // console.log(res.data);
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           // console.log(res.data);
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         // console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // };

  // const handleChangeNumberOfCow = (event) => {
  //   setNumberOfCow(event.target.value);
  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       loanReleaseDate !== "" &&
  //       loanProduct !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       numberOfBuffalo !== "" &&
  //       event.target.value !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           email: email,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: event.target.value,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === 'TOPUP') {
  //     if (
  //       event.target.value !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanProduct !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topup/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: event.target.value,
  //           no_of_buffalo: numberOfBuffalo,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount
  //         })
  //         .then((res) => {
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  // }

  // const handleChangeNumberOfBuffalo = (event) => {
  //   setNumberOfBuffalo(event.target.value);
  //   if (loanType === 'NEW') {
  //     if (
  //       loanReleaseDate !== "" &&
  //       loanProduct !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       numberOfCow !== "" &&
  //       event.target.value !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           email: email,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: event.target.value,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === 'TOPUP') {
  //     if (
  //       event.target.value !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanProduct !== "" &&
  //       loanDuration !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topup/calculate", {
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: event.target.value,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount
  //         })
  //         .then((res) => {
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  // }

  // const handleChangeLoanReleaseDate = (event) => {
  //   setLoanReleaseDate(event.target.value);
  //   // if (loanType === "TOPUP") {
  //   //   if (
  //   //     event.target.value !== "" &&
  //   //     loanProductInterestRate !== "" &&
  //   //     loanDuration !== "" &&
  //   //     pfWaiver !== "" &&
  //   //     lifeInsuranceAmount !== "" &&
  //   //     propertyInsuranceAmount !== "" &&
  //   //     insurancetypeData !== ""
  //   //   ) {
  //   //     setOpen(true);
  //   //     axios
  //   //       .post(url + "/loan/topup/calculate", {
  //   //         token: token,
  //   //         email: email,
  //   //         loan_tenure_start_date: loanTenureStartDate,
  //   //         loan_release_date: event.target.value,
  //   //         loan_duration: loanDuration,
  //   //         loanproduct_interest_rate: loanProductInterestRate,
  //   //         loanproduct_id: loanProduct,
  //   //         borrower_uniqueno: selectBorrower,
  //   //         loan_life_ins: lifeInsuranceAmount,
  //   //         loan_property_ins: propertyInsuranceAmount,
  //   //         pf_waiver: pfWaiver,
  //   //         total_outstanding: totalOutstandingAmount,
  //   //         ins_type: insurancetypeData,
  //   //         loan_topup_amt: topUpAmount,
  //   //         no_of_cow: numberOfCow,
  //   //         no_of_buffalo: numberOfBuffalo
  //   //       })
  //   //       .then((res) => {
  //   //         setOpen(false);
  //   //         if (res.data.auth === true) {
  //   //           if (res.data.message.errorMessage !== "NA") {
  //   //             toast.error(res.data.message.errorMessage)
  //   //           }
  //   //           else {
  //   //             toast.success("Top Up Loan Calculated");
  //   //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //   //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //   //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //   //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //   //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //   //             setloanfeesArray(res.data.message.loanfees_arr);
  //   //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //   //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //   //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //   //             setaprIrr(res.data.message.apr_irr);
  //   //             setpfAmount(res.data.message.pf_amount);
  //   //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //   //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //   //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //   //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //   //             settopUpAmount(res.data.message.loan_topup_amt)
  //   //           }
  //   //         }
  //   //         else {
  //   //           toast.error(res.data.message);
  //   //         }
  //   //       })
  //   //       .catch((err) => {
  //   //         setOpen(false);
  //   //         toast.error(err);
  //   //       });
  //   //   }
  //   // }
  //   // if (loanType === "RESTRUCTURED") {
  //   //   if (
  //   //     loanDuration !== "" &&
  //   //     loanProduct !== "" &&
  //   //     chargesWaiver !== "" &&
  //   //     interestWaiver !== "" &&
  //   //     loanProductInterestRate !== "" &&
  //   //     event.target.value !== "" &&
  //   //     lifeInsuranceAmount !== "" &&
  //   //     propertyInsuranceAmount !== ""
  //   //   ) {
  //   //     setOpen(true);
  //   //     axios
  //   //       .post(url + "/loan/restructure/calculate", {
  //   //         token: token,
  //   //         email: email,
  //   //         borrower_uniqueno: selectBorrower,
  //   //         loan_tenure_start_date: loanTenureStartDate,
  //   //         loanproduct_id: loanProduct,
  //   //         loan_duration: loanDuration,
  //   //         loan_release_date: event.target.value,
  //   //         total_outstanding: totalOutstandingAmount,
  //   //         loanproduct_interest_rate: loanProductInterestRate,
  //   //         charges_waiver: chargesWaiver,
  //   //         interest_waiver: interestWaiver,
  //   //         loan_property_ins: propertyInsuranceAmount?.toString(),
  //   //         loan_life_ins: lifeInsuranceAmount,
  //   //         pending_principal: pendingPrincipal,
  //   //         no_of_cow: numberOfCow,
  //   //         no_of_buffalo: numberOfBuffalo
  //   //       })
  //   //       .then((res) => {
  //   //         console.log(res.data);
  //   //         setOpen(false);
  //   //         if (res.data.auth === true) {
  //   //           if (res.data.message.errorMessage !== "NA") {
  //   //             toast.error(res.data.message.errorMessage)
  //   //           }
  //   //           else {
  //   //             toast.success("Restructured Loan Calculated");
  //   //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //   //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //   //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //   //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //   //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //   //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //   //             setaprIrr(res.data.message.apr_irr);
  //   //             setLoanPrincipalAmount(res.data.message.new_principal_amount)
  //   //             setLoanDisbursedAmount(res.data.message.disbursed_amount);
  //   //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //   //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //   //           }
  //   //         }
  //   //         else {
  //   //           toast.error(res.data.message);
  //   //         }
  //   //       })
  //   //       .catch((err) => {
  //   //         setOpen(false);
  //   //         toast.error(err);
  //   //       });
  //   //   }
  //   // }
  //   // if (loanType === "NEW" || loanType === "REPEAT") {
  //   //   if (
  //   //     event.target.value !== "" &&
  //   //     loanProduct !== "" &&
  //   //     loanProductInterestRate !== "" &&
  //   //     loanDuration !== "" &&
  //   //     pfWaiver !== "" &&
  //   //     lifeInsuranceAmount !== "" &&
  //   //     propertyInsuranceAmount !== ""
  //   //   ) {
  //   //     setOpen(true);
  //   //     axios
  //   //       .post(url + "/loan/calculate", {
  //   //         token: token,
  //   //         email: email,
  //   //         loan_tenure_start_date: loanTenureStartDate,
  //   //         loan_release_date: event.target.value,
  //   //         loan_duration: loanDuration,
  //   //         loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //   //         loanproduct_interest_rate: loanProductInterestRate,
  //   //         loanproduct_id: loanProduct,
  //   //         borrower_uniqueno: selectBorrower,
  //   //         pf_waiver: pfWaiver,
  //   //         loan_life_ins: lifeInsuranceAmount,
  //   //         loan_property_ins: propertyInsuranceAmount,
  //   //         no_of_cow: numberOfCow,
  //   //         no_of_buffalo: numberOfBuffalo,
  //   //         trancheArray: trancheArray
  //   //       })
  //   //       .then((res) => {
  //   //         // console.log(res.data);
  //   //         setOpen(false);
  //   //         if (res.data.auth === true) {
  //   //           // console.log(res.data);
  //   //           if (res.data.message.errorMessage !== "NA") {
  //   //             toast.error(res.data.message.errorMessage)
  //   //           }
  //   //           else {
  //   //             toast.success("Loan Calculated");
  //   //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //   //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //   //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //   //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //   //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //   //             setloanfeesArray(res.data.message.loanfees_arr);
  //   //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //   //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //   //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //   //             setaprIrr(res.data.message.apr_irr);
  //   //             setpfAmount(res.data.message.pf_amount);
  //   //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //   //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //   //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //   //           }
  //   //         }
  //   //         else {
  //   //           toast.error(res.data.message);
  //   //         }
  //   //       })
  //   //       .catch((err) => {
  //   //         setOpen(false);
  //   //         // console.log(err);
  //   //         toast.error(err);
  //   //       });
  //   //   }
  //   // }
  //   // if (loanType === "TOPUP + BT") {
  //   //   if (
  //   //     event.target.value !== "" &&
  //   //     loanProductInterestRate !== "" &&
  //   //     loanDuration !== "" &&
  //   //     pfWaiver !== "" &&
  //   //     lifeInsuranceAmount !== "" &&
  //   //     propertyInsuranceAmount !== "" &&
  //   //     insurancetypeData !== ""
  //   //   ) {
  //   //     setOpen(true);
  //   //     axios
  //   //       .post(url + "/loan/topupbt/calculate", {
  //   //         token: token,
  //   //         email: email,
  //   //         loan_tenure_start_date: loanTenureStartDate,
  //   //         loan_release_date: event.target.value,
  //   //         loan_duration: loanDuration,
  //   //         loanproduct_interest_rate: loanProductInterestRate,
  //   //         loanproduct_id: loanProduct,
  //   //         borrower_uniqueno: selectBorrower,
  //   //         loan_life_ins: lifeInsuranceAmount,
  //   //         loan_property_ins: propertyInsuranceAmount,
  //   //         pf_waiver: pfWaiver,
  //   //         total_outstanding: totalOutstandingAmount,
  //   //         ins_type: insurancetypeData,
  //   //         loan_topup_amt: topUpAmount,
  //   //         no_of_cow: numberOfCow,
  //   //         no_of_buffalo: numberOfBuffalo
  //   //       })
  //   //       .then((res) => {
  //   //         setOpen(false);
  //   //         if (res.data.auth === true) {
  //   //           if (res.data.message.errorMessage !== "NA") {
  //   //             toast.error(res.data.message.errorMessage)
  //   //           }
  //   //           else {
  //   //             toast.success("Top Up Loan Calculated");
  //   //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //   //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //   //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //   //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //   //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //   //             setloanfeesArray(res.data.message.loanfees_arr);
  //   //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //   //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //   //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //   //             setaprIrr(res.data.message.apr_irr);
  //   //             setpfAmount(res.data.message.pf_amount);
  //   //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //   //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //   //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //   //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //   //             settopUpAmount(res.data.message.loan_topup_amt)
  //   //           }
  //   //         }
  //   //         else {
  //   //           toast.error(res.data.message);
  //   //         }
  //   //       })
  //   //       .catch((err) => {
  //   //         setOpen(false);
  //   //         toast.error(err);
  //   //       });
  //   //   }
  //   // }
  // };

  // const handleChangeLoanDuration = (event) => {
  //   setLoanDuration(event.target.value);
  //   if (loanType === "TOPUP") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topup/calculate", {
  //           token: token,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: event.target.value,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }

  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProduct !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           token: token,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: event.target.value,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: pfWaiver,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             // console.log(res.data);
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           // console.log(err);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "TOPUP + BT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       pfWaiver !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topupbt/calculate", {
  //           token: token,
  //           loan_tenure_start_date: loanTenureStartDate,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: event.target.value,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: pfWaiver,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  // };

  // const handleChangetopUpAmount = (event) => {
  //   settopUpAmount(event.target.value);
  //   if (
  //     loanProductInterestRate !== "" &&
  //     loanReleaseDate !== "" &&
  //     loanDuration !== "" &&
  //     pfWaiver !== "" &&
  //     lifeInsuranceAmount !== "" &&
  //     propertyInsuranceAmount !== "" &&
  //     insurancetypeData !== ""
  //   ) {
  //     setOpen(true);
  //     axios
  //       .post(url + "/loan/topup/calculate", {
  //         token: token,
  //         loan_tenure_start_date: loanTenureStartDate,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: lifeInsuranceAmount,
  //         loan_property_ins: propertyInsuranceAmount,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: insurancetypeData,
  //         loan_topup_amt: event.target.value,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         toast.error(err);
  //       });
  //   }
  // };

  // const handleChangepfWaiver = (event) => {
  //   setpfWaiver(event.target.value);
  //   if (loanType === "TOPUP") {
  //     if (
  //       event.target.value !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanDuration !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topup/calculate", {
  //           loan_tenure_start_date: loanTenureStartDate,
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: event.target.value,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "NEW" || loanType === "REPEAT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanProduct !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanReleaseDate !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/calculate", {
  //           loan_tenure_start_date: loanTenureStartDate,
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           pf_waiver: event.target.value,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo,
  //           trancheArray: trancheArray
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             // console.log(res.data);
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           // console.log(err);
  //           toast.error(err);
  //         });
  //     }
  //   }
  //   if (loanType === "TOPUP + BT") {
  //     if (
  //       event.target.value !== "" &&
  //       loanReleaseDate !== "" &&
  //       loanProductInterestRate !== "" &&
  //       loanDuration !== "" &&
  //       lifeInsuranceAmount !== "" &&
  //       propertyInsuranceAmount !== "" &&
  //       insurancetypeData !== ""
  //     ) {
  //       setOpen(true);
  //       axios
  //         .post(url + "/loan/topupbt/calculate", {
  //           loan_tenure_start_date: loanTenureStartDate,
  //           token: token,
  //           email: email,
  //           loan_release_date: loanReleaseDate,
  //           loan_duration: loanDuration,
  //           loanproduct_interest_rate: loanProductInterestRate,
  //           loanproduct_id: loanProduct,
  //           borrower_uniqueno: selectBorrower,
  //           loan_life_ins: lifeInsuranceAmount,
  //           loan_property_ins: propertyInsuranceAmount,
  //           pf_waiver: event.target.value,
  //           total_outstanding: totalOutstandingAmount,
  //           ins_type: insurancetypeData,
  //           loan_topup_amt: topUpAmount,
  //           no_of_cow: numberOfCow,
  //           no_of_buffalo: numberOfBuffalo
  //         })
  //         .then((res) => {
  //           console.log(res.data);
  //           setOpen(false);
  //           if (res.data.auth === true) {
  //             if (res.data.message.errorMessage !== "NA") {
  //               toast.error(res.data.message.errorMessage)
  //             }
  //             else {
  //               toast.success("Top Up Loan Calculated");
  //               setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //               setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //               setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //               setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //               setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //               setloanfeesArray(res.data.message.loanfees_arr);
  //               setLoanEmiAmount(res.data.message.loan_emi_amt);
  //               setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //               setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //               setaprIrr(res.data.message.apr_irr);
  //               setpfAmount(res.data.message.pf_amount);
  //               setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //               setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //               // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //               setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //               settopUpAmount(res.data.message.loan_topup_amt)
  //             }
  //           }
  //           else {
  //             toast.error(res.data.message);
  //           }
  //         })
  //         .catch((err) => {
  //           setOpen(false);
  //           toast.error(err);
  //         });
  //     }
  //   }
  // };

  const handleChangeLoanType = (event) => {
    setLoanType(event.target.value);
    setIsFirstCalculateClicked(false);
    if (event.target.value === "TOPUP" || event.target.value === "TOPUP + BT") {
      axios
        .post(url + "/loan/topup/typechange", {
          token: token,
          email: email,
          borrower_uniqueno: selectBorrower,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === false) {
            toast.error(res.data.message);
          } else {
            setTotalOutstandingAmount(res.data.message);
          }
        });
    }
  };

  useEffect(() => {
    if (!state) {
      navigate("/");
    } else {
      setCurrentTrancheNumber(state.loan_tranche_number)
      setCurrentTrancheArr(state.loan_tranche_arr)
      // console.log("EDITING");
      // console.log(state,"state");
      // console.log(state.loan_type,"Loan Type");
      axios
        .post(url + "/loanproduct/getsingle", {
          token: token,
          email: email,
          loanproduct_id: state.loanproduct_id,
        })
        .then((res) => {
          if (res.data[0].loanproduct_group === 'DAIRY LOAN') {
            setLoanProductGroupDairy(true)
          } else {
            setLoanProductGroupDairy(false)
          }
          setIsLIInternal(res.data[0].loanproduct_life_ins?.loanproduct_insurance === "INTERNAL")
          setShowLifeIns(
            res.data[0].loanproduct_life_ins.life_ins
              ? res.data[0].loanproduct_life_ins.life_ins
              : ""
          );
          setShowPropertyIns(
            res.data[0].loanproduct_property_ins
              ? res.data[0].loanproduct_property_ins.property_ins
              : ""
          );
          setShowCattleIns(
            res.data[0].loanproduct_cattle_ins
              ? res.data[0].loanproduct_cattle_ins.cattle_ins
              : ""
          );
          setlifeInsuranceTitle(
            res.data[0].loanproduct_life_ins.loanproduct_insurance
              ? res.data[0].loanproduct_life_ins.loanproduct_insurance
              : ""
          );
          setpropertyInsuranceTitle(
            res.data[0].loanproduct_property_ins
              ? res.data[0].loanproduct_property_ins.loanproduct_insurance
              : ""
          );
          setCattleInsuranceTitle(
            res.data[0].loanproduct_cattle_ins
              ? res.data[0].loanproduct_cattle_ins.loanproduct_insurance
              : ""
          );
          setAutoComputeLoanAmount(
            res.data[0].autoComputeLoanAmount ? res.data[0].autoComputeLoanAmount : false
          )
        })
        .catch((err) => {
          console.log(err);
        });
      setloanfeesArray(state?.loanfees_arr ?? [])
      setpendingPrincipal(state.pending_principal);
      setpendingInterest(state.pending_interest)
      setpendingCharges(state.pending_charges)
      setWaiver(state.waiver);
      setNetOutstandingAmount(state.netOutstandingAmount);
      setNetPf(state.netPf)
      setchargesWaiver(state.charges_waiver)
      setinterestWaiver(state.interest_waiver)
      setTotalOutstandingAmount(state.total_outstanding);
      setinsurancetypeData(state.ins_type);
      setloanDisbursedAmtCus(state.loan_disbursed_amt_cus);
      settopUpAmount(state.loan_topup_amt)
      setLoanEmiAmount(state.loan_emi_amt);
      setaprIrr(state.APRasPerIRR);
      setLoanId(state.loan_id);
      setSelectBorrower(state.borrower_uniqueno);
      setLoanProduct(state.loanproduct_id);
      // setLoanType(state.loan_type);
      setLoanProductInterestRate(state.loanproduct_interest_rate);
      setLoanPrincipalAmount(state.loan_principal_amt);
      setLoanReleaseDate(state.loan_release_date);
      setLoanTenureStartDate(state.loan_tenure_start_date);
      setLoanPreEmiInterest(state.loan_pre_emi_interest);
      setLoanEmiStartDate(state.loan_emi_start_date);
      setLoanEmiLastDate(state.loan_emi_last_date);
      setLoanDisbursedAmount(state.loan_disbursed_amt);
      setpfAmount(state.pf_amount);
      setpfWaiver(state.pf_waiver);
      setLoanDuration(state.loan_duration);
      setlifeInsuranceAmount(state.loan_life_ins);
      setpropertyInsuranceAmount(state.loan_property_ins);
      setcattleInsuranceAmount(state.loan_cattle_ins)
      setNumberOfCow(state.number_of_cow)
      setNumberOfBuffalo(state.number_of_buffalo)
      setAdvanceEmi(state.loan_advance_emi_number);
      setNumberOfTranche(state.loan_tranche_number);
      setSelectGuarantors(state.loan_gaurantors);
      setLoanComments(state.loan_comments);
      setLoanPurpose(state.loan_purpose);
      setPriceOfCow(state.price_of_cow);
      setPriceOfBuffalo(state.price_of_buffalo);
      setcattleInsuranceTenure(state.cattle_Insurance_Tenure)
      setIsDisbursed(state.loan_status === "DISBURSED");
    }
    axios
      .post(url + "/loan/getsingle", {
        token: token,
        email: email,
        loan_id: state.loan_id
      })
      .then((res) => {
        setIsDisbursed(res?.data[0]?.loan_status === "DISBURSED");
        if (res.data[0].loan_status === "PARTLY DISBURSED") {
          setDropdownDisabled(true);
          setPartlyDisbursed(true)
        }
        if (res.data.logout === true) {
          toast.error(res.data.message);
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message);
      });

    axios
      .post(url + "/loanproduct/dropdownarray", {
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === false) {
        } else {
          // console.log(res.data);
          setData2(res.data);
        }
      });

    // axios
    //   .post(url + "/loan/previous/loan/check", {
    //     token: token,
    //     email: email,
    //     borrowerUniqueNo: state.borrower_uniqueno
    //   })
    //   .then((res) => {
    //     // console.log(res.data.data)
    //     setDropdownLoanObj(res.data.data)
    //   });

    axios
      .post(url + "/loan/previous/loan/check", {
        token,
        email,
        borrowerUniqueNo: state.borrower_uniqueno
      })
      .then((res) => {
        const data = res.data.data;
        setDropdownLoanObj(data);
        if (state.loan_type) {
          setLoanType(state.loan_type);
          return;
        }
        if (data.loanCount === 1) {
          setLoanType("NEW");
        } else if (data.loanCount > 1) {
          setLoanType("");
        }
      });
  }, [token, email, state, navigate]);

  const handleUpdateAddLoan = (e) => {
    e.preventDefault();
    setOpen(true);
    // Below code will remove the additional default tranche array objects (8 defined) and confine it to actual
    const fullTrancheArr = trancheArray.slice(0, numberOfTranche)
    console.log(fullTrancheArr, 'fulltranche')
    // console.log(trancheValue1, trancheValue2, trancheValue3, trancheValue4);
    axios
      .post(url + "/loan/update", {
        token: token,
        email: email,
        loan_id: loanId,
        borrower_uniqueno: selectBorrower,
        loanproduct_id: loanProduct,
        loan_type: loanType,
        loanproduct_interest_rate: loanProductInterestRate,
        loan_principal_amt: loanPrincipalAmount,
        loan_release_date: loanReleaseDate,
        loan_tenure_start_date: loanTenureStartDate,
        loan_pre_emi_interest: loanPreEmiInterest ? loanPreEmiInterest : 0,
        loan_emi_start_date: loanEmiStartDate,
        loan_emi_last_date: loanEmiLastDate,
        loan_duration: loanDuration,
        loan_advance_emi_number: advanceEmi,
        loan_tranche_number: numberOfTranche,
        loan_tranche_arr: fullTrancheArr,
        loan_disbursed_amt: loanDisbursedAmount,
        loan_gaurantors: selectGuarantors,
        loan_comments: loanComments,
        loan_life_ins: showLifeIns ? lifeInsuranceAmount : "",
        loan_property_ins: showPropertyIns ? propertyInsuranceAmount : "",
        loan_cattle_ins: showCattleIns ? cattleInsuranceAmount : "",
        number_of_cow: numberOfCow,
        number_of_buffalo: numberOfBuffalo,
        loanfees_arr: loanfeesArray,
        loan_emi_amt: loanEmiAmount,
        APRasPerIRR: aprIrr,
        pf_waiver: pfWaiver,
        pf_amount: pfAmount,
        total_outstanding: totalOutstandingAmount,
        loan_disbursed_amt_cus: loanDisbursedAmtCus,
        ins_type: insurancetypeData,
        loan_topup_amt: topUpAmount,
        pending_principal: pendingPrincipal,
        pending_interest: pendingInterest,
        pending_charges: pendingCharges,
        waiver: waiver,
        net_outstanding: netOutstandingAmount,
        net_pf_amount: netPf,
        charges_waiver: chargesWaiver,
        interest_waiver: interestWaiver,
        // loan_purpose: loanPurpose
        loan_purpose: loanPurpose,
        price_of_cow: priceOfCow,
        price_of_buffalo: priceOfBuffalo,
        cattle_Insurance_Tenure: cattleInsuranceTenure,
        loan_repayment: repaymentArray
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === false) {
          setOpen(false);
          toast.error(res.data.message);
        } else {
          setOpen(false);
          toast.success(res.data.message);
          setTimeout(() => {
            // navigate("/loan/created");
            window.location.reload();
          }, 3000);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err);
      });
  };

  // const handletopupAmountRadio = (event) => {
  //   console.log(event.target.value);
  //   setinsurancetypeData(event.target.value);
  //   if (
  //     event.target.value !== "" &&
  //     loanProduct !== "" &&
  //     loanProductInterestRate !== "" &&
  //     loanReleaseDate !== "" &&
  //     loanDuration !== "" &&
  //     pfWaiver !== "" &&
  //     lifeInsuranceAmount !== "" &&
  //     propertyInsuranceAmount !== ""
  //   ) {
  //     setOpen(true);
  //     axios
  //       .post(url + "/loan/topup/calculate", {
  //         loan_tenure_start_date: loanTenureStartDate,
  //         token: token,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: lifeInsuranceAmount,
  //         loan_property_ins: propertyInsuranceAmount,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: event.target.value,
  //         loan_topup_amt: topUpAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         toast.error(err);
  //       });
  //   }
  // };

  // const handleprincipalAmountRadio = (event) => {
  //   console.log(event.target.value);
  //   setinsurancetypeData(event.target.value);
  //   if (
  //     event.target.value !== "" &&
  //     loanProductInterestRate !== "" &&
  //     loanProduct !== "" &&
  //     loanDuration !== "" &&
  //     pfWaiver !== "" &&
  //     lifeInsuranceAmount !== "" &&
  //     propertyInsuranceAmount !== "" &&
  //     loanReleaseDate !== ""
  //   ) {
  //     setOpen(true);
  //     axios
  //       .post(url + "/loan/topup/calculate", {
  //         loan_tenure_start_date: loanTenureStartDate,
  //         token: token,
  //         email: email,
  //         loan_release_date: loanReleaseDate,
  //         loan_duration: loanDuration,
  //         loanproduct_interest_rate: loanProductInterestRate,
  //         loanproduct_id: loanProduct,
  //         borrower_uniqueno: selectBorrower,
  //         loan_life_ins: lifeInsuranceAmount,
  //         loan_property_ins: propertyInsuranceAmount,
  //         pf_waiver: pfWaiver,
  //         total_outstanding: totalOutstandingAmount,
  //         ins_type: event.target.value,
  //         loan_topup_amt: topUpAmount,
  //         no_of_cow: numberOfCow,
  //         no_of_buffalo: numberOfBuffalo
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         setOpen(false);
  //         if (res.data.auth === true) {
  //           if (res.data.message.errorMessage !== "NA") {
  //             toast.error(res.data.message.errorMessage)
  //           }
  //           else {
  //             toast.success("Top Up Loan Calculated");
  //             setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //             setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //             setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //             setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //             setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //             setloanfeesArray(res.data.message.loanfees_arr);
  //             setLoanEmiAmount(res.data.message.loan_emi_amt);
  //             setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //             setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //             setaprIrr(res.data.message.apr_irr);
  //             setpfAmount(res.data.message.pf_amount);
  //             setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //             setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //             // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //             setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //             settopUpAmount(res.data.message.loan_topup_amt)
  //           }
  //         }
  //         else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // };

  // const handleChangeLoanPurpose = (e) => {
  //   setLoanPurpose(e.target.value);
  // }

  const handleTrancheDetails = (newData) => {
    setTrancheArray(newData)
  }
  //   useEffect(()=>{
  //     console.log(loanType);
  //     let response = setTimeout(() => {
  //       if (loanType === "TOPUP") {
  //         if (
  //           loanProduct !== "" &&
  //           loanProductInterestRate !== "" &&
  //           loanDuration !== "" &&
  //           loanReleaseDate !== ""
  //         ) {
  //           setOpen(true);
  //           axios
  //             .post(url + "/loan/topup/calculate", {
  //               token: token,
  //               email: email,
  //               loan_release_date: loanReleaseDate,
  //               loan_tenure_start_date: loanTenureStartDate,
  //               loan_duration: loanDuration,
  //               loanproduct_interest_rate: loanProductInterestRate,
  //               loanproduct_id: loanProduct,
  //               borrower_uniqueno: selectBorrower,
  //               loan_life_ins: lifeInsuranceAmount,
  //               loan_cattle_ins: cattleInsuranceAmount,
  //               loan_property_ins: propertyInsuranceAmount,
  //               pf_waiver: pfWaiver,
  //               total_outstanding: totalOutstandingAmount,
  //               ins_type: insurancetypeData,
  //               no_of_cow: numberOfCow,
  //               no_of_buffalo: numberOfBuffalo,
  //               loan_topup_amt: topUpAmount
  //             })
  //             .then((res) => {
  //               setOpen(false);
  //               if (res.data.auth === true) {
  //                 if (res.data.message.errorMessage !== "NA") {
  //                   toast.error(res.data.message.errorMessage)
  //                 }
  //                 else {
  //                   toast.success("Top Up Loan Calculated");
  //                   setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //                   setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //                   setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //                   setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //                   setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //                   setloanfeesArray(res.data.message.loanfees_arr);
  //                   setLoanEmiAmount(res.data.message.loan_emi_amt);
  //                   setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //                   setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //                   setaprIrr(res.data.message.apr_irr);
  //                   setpfAmount(res.data.message.pf_amount);
  //                   setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //                   setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //                   // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //                   setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //                   settopUpAmount(res.data.message.loan_topup_amt)
  //                 }
  //               }
  //               else {
  //                 toast.error(res.data.message);
  //               }
  //             })
  //             .catch((err) => {
  //               setOpen(false);
  //               toast.error(err);
  //             });
  //         }
  //       }
  //       if (loanType === "NEW" || loanType === "REPEAT") {
  //         if (
  //           loanProduct !== "" &&
  //           loanProductInterestRate !== "" &&
  //           loanDuration !== "" &&
  //           loanReleaseDate !== ""
  //         ) {
  //           setOpen(true);
  //           axios
  //             .post(url + "/loan/calculate", {
  //               token: token,
  //               email: email,
  //               loan_release_date: loanReleaseDate,
  //               loan_duration: loanDuration,
  //               loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
  //               loanproduct_interest_rate: loanProductInterestRate,
  //               loan_tenure_start_date: loanTenureStartDate,
  //               loanproduct_id: loanProduct,
  //               borrower_uniqueno: selectBorrower,
  //               pf_waiver: pfWaiver,
  //               loan_life_ins: lifeInsuranceAmount,
  //               loan_cattle_ins: cattleInsuranceAmount,
  //               no_of_cow: numberOfCow,
  //               no_of_buffalo: numberOfBuffalo,
  //               loan_property_ins: propertyInsuranceAmount,
  //               trancheArray: trancheArray
  //             })
  //             .then((res) => {
  //               // console.log(res.data);
  //               setOpen(false);
  //               if (res.data.auth === true) {
  //                 // console.log(res.data);
  //                 if (res.data.message.errorMessage !== "NA") {
  //                   toast.error(res.data.message.errorMessage)
  //                 }
  //                 else {
  //                   toast.success("Loan Calculated");
  //                   setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //                   setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //                   setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //                   setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //                   setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //                   setloanfeesArray(res.data.message.loanfees_arr);
  //                   setLoanEmiAmount(res.data.message.loan_emi_amt);
  //                   setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //                   setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //                   setaprIrr(res.data.message.apr_irr);
  //                   setpfAmount(res.data.message.pf_amount);
  //                   // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //                   setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //                   setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //                 }
  //               }
  //               else {
  //                 toast.error(res.data.message);
  //               }
  //             })
  //             .catch((err) => {
  //               setOpen(false);
  //               // console.log(err);
  //               toast.error(err);
  //             });
  //         }
  //       }
  //       if (loanType === "TOPUP + BT") {
  //         if (
  //           loanProduct !== "" &&
  //           loanProductInterestRate !== "" &&
  //           loanDuration !== "" &&
  //           loanReleaseDate !== ""
  //         ) {
  //           setOpen(true);
  //           axios
  //             .post(url + "/loan/topupbt/calculate", {
  //               token: token,
  //               email: email,
  //               loan_release_date: loanReleaseDate,
  //               loan_tenure_start_date: loanTenureStartDate,
  //               loan_duration: loanDuration,
  //               loanproduct_interest_rate: loanProductInterestRate,
  //               loanproduct_id: loanProduct,
  //               borrower_uniqueno: selectBorrower,
  //               loan_life_ins: lifeInsuranceAmount,
  //               loan_cattle_ins: cattleInsuranceAmount,
  //               loan_property_ins: propertyInsuranceAmount,
  //               pf_waiver: pfWaiver,
  //               total_outstanding: totalOutstandingAmount,
  //               ins_type: insurancetypeData,
  //               no_of_cow: numberOfCow,
  //               no_of_buffalo: numberOfBuffalo,
  //               loan_topup_amt: topUpAmount
  //             })
  //             .then((res) => {
  //               // console.log(res.data);
  //               setOpen(false);
  //               if (res.data.auth === true) {
  //                 if (res.data.message.errorMessage !== "NA") {
  //                   toast.error(res.data.message.errorMessage)
  //                 }
  //                 else {
  //                   toast.success("Top Up Loan Calculated");
  //                   setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
  //                   setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
  //                   setLoanEmiStartDate(res.data.message.loan_emi_start_date);
  //                   setLoanEmiLastDate(res.data.message.loan_emi_last_date);
  //                   setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
  //                   setloanfeesArray(res.data.message.loanfees_arr);
  //                   setLoanEmiAmount(res.data.message.loan_emi_amt);
  //                   setlifeInsuranceAmount(res.data.message.loan_life_ins);
  //                   setpropertyInsuranceAmount(res.data.message.loan_property_ins);
  //                   setaprIrr(res.data.message.apr_irr);
  //                   setpfAmount(res.data.message.pf_amount);
  //                   setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
  //                   setLoanPrincipalAmount(res.data.message.loan_principal_amt)
  //                   // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
  //                   setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
  //                   settopUpAmount(res.data.message.loan_topup_amt)
  //                 }
  //               }
  //               else {
  //                 toast.error(res.data.message);
  //               }
  //             })
  //             .catch((err) => {
  //               setOpen(false);
  //               toast.error(err);
  //             });
  //         }
  //       }
  //     }, 1000);
  //     return () => {
  //       clearTimeout(response)
  //     }
  //   // eslint-disable-next-line
  // }, [trancheArray,loanProduct,loanProductInterestRate,lifeInsuranceAmount,propertyInsuranceAmount,numberOfCow,numberOfBuffalo,loanPrincipalAmount,loanReleaseDate,loanDuration,loanTenureStartDate,topUpAmount,pfWaiver,insurancetypeData, cattleInsuranceAmount])

  // const handleCattleInsuranceChange = (e) => {
  //   if (cattleInsuranceTitle === "EXTERNAL") {
  //     setcattleInsuranceAmount(e.target.value);
  //   }
  // };

  const handleCalculateLoan = (buttonId) => {
    console.log(loanType);
    console.log(buttonId);
    // if (buttonId === 1) setIsSecondCalculateClicked(false);
    if (loanType === "TOPUP") {
      if (
        loanProduct !== "" &&
        loanProductInterestRate !== "" &&
        loanDuration !== "" &&
        loanReleaseDate !== ""
      ) {
        setOpen(true);
        axios
          .post(url + "/loan/topup/calculate", {
            token: token,
            email: email,
            loan_release_date: loanReleaseDate,
            loan_tenure_start_date: loanTenureStartDate,
            loan_duration: loanDuration,
            loanproduct_interest_rate: loanProductInterestRate,
            loanproduct_id: loanProduct,
            borrower_uniqueno: selectBorrower,
            loan_life_ins: lifeInsuranceAmount,
            loan_cattle_ins: cattleInsuranceAmount,
            loan_property_ins: propertyInsuranceAmount,
            pf_waiver: pfWaiver,
            total_outstanding: netOutstandingAmount,
            ins_type: insurancetypeData,
            no_of_cow: numberOfCow || 0,
            no_of_buffalo: numberOfBuffalo || 0,
            loan_topup_amt: topUpAmount,
            price_of_cow: priceOfCow || 0,
            price_of_buffalo: priceOfBuffalo || 0,
            cattle_Insurance_Tenure: cattleInsuranceTenure,
            loan_id: loanId
          })
          .then((res) => {
            setOpen(false);
            if (res.data.auth === true) {
              if (res.data.message.errorMessage !== "NA") {
                toast.error(res.data.message.errorMessage)
              }
              else {
                toast.success("Top Up Loan Calculated");
                if (buttonId === 1) setIsSecondCalculateClicked(false);
                setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
                setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
                setLoanEmiStartDate(res.data.message.loan_emi_start_date);
                setLoanEmiLastDate(res.data.message.loan_emi_last_date);
                setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
                setloanfeesArray(res.data.message.loanfees_arr);
                setLoanEmiAmount(res.data.message.loan_emi_amt);
                setlifeInsuranceAmount(res.data.message.loan_life_ins);
                setpropertyInsuranceAmount(res.data.message.loan_property_ins);
                setaprIrr(res.data.message.apr_irr);
                setpfAmount(res.data.message.pf_amount);
                setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
                setLoanPrincipalAmount(res.data.message.loan_principal_amt)
                // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
                setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
                settopUpAmount(res.data.message.loan_topup_amt)
                if (buttonId === 1) setIsFirstCalculateClicked(true);
                else if (buttonId === 2) setIsSecondCalculateClicked(true);
              }
            }
            else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            setOpen(false);
            toast.error(err);
          });
      }
    }
    if (loanType === "NEW" || loanType === "REPEAT") {
      if (
        loanProduct !== "" &&
        loanProductInterestRate !== "" &&
        loanDuration !== "" &&
        loanReleaseDate !== ""
      ) {
        setOpen(true);
        axios
          .post(url + "/loan/calculate", {
            token: token,
            email: email,
            loan_release_date: loanReleaseDate,
            loan_duration: loanDuration,
            loan_principal_amt: loanPrincipalAmount === "" ? 0 : loanPrincipalAmount,
            loanproduct_interest_rate: loanProductInterestRate,
            loan_tenure_start_date: loanTenureStartDate,
            loanproduct_id: loanProduct,
            borrower_uniqueno: selectBorrower,
            pf_waiver: pfWaiver,
            loan_life_ins: lifeInsuranceAmount,
            loan_cattle_ins: cattleInsuranceAmount,
            no_of_cow: numberOfCow || 0,
            no_of_buffalo: numberOfBuffalo || 0,
            loan_property_ins: propertyInsuranceAmount,
            trancheArray: trancheArray,
            price_of_cow: priceOfCow || 0,
            price_of_buffalo: priceOfBuffalo || 0,
            cattle_Insurance_Tenure: cattleInsuranceTenure,
            loan_id: loanId
          })
          .then((res) => {
            // console.log(res.data);
            setOpen(false);
            if (res.data.auth === true) {
              // console.log(res.data);
              if (res.data.message.errorMessage !== "NA") {
                toast.error(res.data.message.errorMessage)
              }
              else {
                toast.success("Loan Calculated");
                if (buttonId === 1) setIsSecondCalculateClicked(false);
                setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
                setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
                setLoanEmiStartDate(res.data.message.loan_emi_start_date);
                setLoanEmiLastDate(res.data.message.loan_emi_last_date);
                setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
                setloanfeesArray(res.data.message.loanfees_arr);
                setLoanEmiAmount(res.data.message.loan_emi_amt);
                setlifeInsuranceAmount(res.data.message.loan_life_ins);
                setpropertyInsuranceAmount(res.data.message.loan_property_ins);
                setaprIrr(res.data.message.apr_irr);
                setpfAmount(res.data.message.pf_amount);
                // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
                setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
                setLoanPrincipalAmount(res.data.message.loan_principal_amt)
                setRepaymentArray(res.data?.message?.repaymentArray)
                if (buttonId === 1) setIsFirstCalculateClicked(true);
                else if (buttonId === 2) setIsSecondCalculateClicked(true);
              }
            }
            else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            setOpen(false);
            // console.log(err);
            toast.error(err);
          });
      }
    }
    if (loanType === "TOPUP + BT") {
      if (
        loanProduct !== "" &&
        loanProductInterestRate !== "" &&
        loanDuration !== "" &&
        loanReleaseDate !== ""
      ) {
        setOpen(true);
        axios
          .post(url + "/loan/topupbt/calculate", {
            token: token,
            email: email,
            loan_release_date: loanReleaseDate,
            loan_tenure_start_date: loanTenureStartDate,
            loan_duration: loanDuration,
            loanproduct_interest_rate: loanProductInterestRate,
            loanproduct_id: loanProduct,
            borrower_uniqueno: selectBorrower,
            loan_life_ins: lifeInsuranceAmount,
            loan_cattle_ins: cattleInsuranceAmount,
            loan_property_ins: propertyInsuranceAmount,
            pf_waiver: pfWaiver,
            total_outstanding: netOutstandingAmount,
            ins_type: insurancetypeData,
            no_of_cow: numberOfCow || 0,
            no_of_buffalo: numberOfBuffalo || 0,
            loan_topup_amt: topUpAmount,
            price_of_cow: priceOfCow || 0,
            price_of_buffalo: priceOfBuffalo || 0,
            cattle_Insurance_Tenure: cattleInsuranceTenure,
            loan_id: loanId
          })
          .then((res) => {
            console.log(res.data);
            setOpen(false);
            if (res.data.auth === true) {
              if (res.data.message.errorMessage !== "NA") {
                toast.error(res.data.message.errorMessage)
              }
              else {
                toast.success("Top Up Loan Calculated");
                if (buttonId === 1) setIsSecondCalculateClicked(false);
                setLoanTenureStartDate(res.data.message.loan_tenure_start_date);
                setLoanPreEmiInterest(res.data.message.loan_pre_emi_interest);
                setLoanEmiStartDate(res.data.message.loan_emi_start_date);
                setLoanEmiLastDate(res.data.message.loan_emi_last_date);
                setLoanDisbursedAmount(res.data.message.loan_disbursed_amt);
                setloanfeesArray(res.data.message.loanfees_arr);
                setLoanEmiAmount(res.data.message.loan_emi_amt);
                setlifeInsuranceAmount(res.data.message.loan_life_ins);
                setpropertyInsuranceAmount(res.data.message.loan_property_ins);
                setaprIrr(res.data.message.apr_irr);
                setpfAmount(res.data.message.pf_amount);
                setloanDisbursedAmtCus(res.data.message.loan_disbursed_amt_cus);
                setLoanPrincipalAmount(res.data.message.loan_principal_amt)
                // handleChangeNumberOfTrancheDefault(loanReleaseDate, res.data.message.loan_disbursed_amt, res.data.message.loan_principal_amt);
                setcattleInsuranceAmount(res.data.message.loan_cattle_ins)
                settopUpAmount(res.data.message.loan_topup_amt)
                if (buttonId === 1) setIsFirstCalculateClicked(true);
                else if (buttonId === 2) setIsSecondCalculateClicked(true);
              }
            }
            else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            setOpen(false);
            toast.error(err);
          });
      }
    }
  }

  useEffect(() => {
    if (isFirstCalculateClicked && isSecondCalculateClicked) {
      setIsUpdateDisabled(false);
    }
    if (!isFirstCalculateClicked || !isSecondCalculateClicked) {
      setIsUpdateDisabled(true);
    }
  }, [isFirstCalculateClicked, isSecondCalculateClicked]);

  useEffect(() => {
    if (!isFirstCalculateClicked) {
      setIsSecondCalculateClicked(true);
    }
  }, [isFirstCalculateClicked]);

  return (
    <>
      <Sidebar click={openView} />
      <div style={{ height: "3vh" }} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s " }}
      >
        <div className="main-container">
          <div className="content-container">
            <div className="main-add-loan">
              <h3 className="main-heading">
                <ArticleOutlinedIcon />
                <strong> Edit Loan</strong>
              </h3>
              <form className="form-add-loan" onSubmit={handleUpdateAddLoan}>
                <div className="bank-details-add-loan">
                  <div className="input-item">
                    <label>Borrower Id</label>
                    <br />
                    <br />
                    <TextField
                      className="lms-input-field"
                      placeholder="Select Borrower"
                      // select
                      disabled
                      name="select-borrower"
                      variant="outlined"
                      size="small"
                      // required
                      value={selectBorrower}
                      onChange={(e) => setSelectBorrower(e.target.value)}
                    />
                  </div>
                  <div className="input-item">
                    <label>Loan Type</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      select
                      name="loan-type"
                      variant="outlined"
                      value={loanType}
                      size="small"
                      onChange={handleChangeLoanType}
                      disabled
                    >
                      <MenuItem value="">Select Loan Type</MenuItem>
                      <MenuItem disabled={dropdownLoanObj.loanCount > 1} value="NEW">NEW</MenuItem>
                      <MenuItem disabled={dropdownLoanObj.repeatCheck} value="REPEAT">REPEAT</MenuItem>
                      <MenuItem disabled={dropdownLoanObj.topupCheck} value="TOPUP">TOPUP</MenuItem>
                      <MenuItem disabled={dropdownLoanObj.topupbtCheck} value="TOPUP + BT">TOPUP + BT</MenuItem>
                    </TextField>
                  </div>
                  <div className="input-item">
                    <label>Select Loan Product</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      select
                      name="select-loan-product"
                      variant="outlined"
                      placeholder="Please Enter Loan Product"
                      value={loanProduct}
                      size="small"
                      onChange={handleChangeLoanProduct}
                      disabled={isDropdownDisabled || isDisbursed}

                    >
                      {data2?.map((data2, id2) => (
                        <MenuItem
                          key={id2}
                          value={data2.loanproduct_id}
                          disabled={!data2.is_active || isDisbursed}
                        >
                          {data2.loanproduct_name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </div>
                <h3 className="heading-three">Interest</h3>
                <div className="bank-details-add-loan">
                  <div className="input-item">
                    <label>Loan Product Interest Rate %</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="interest-rate"
                      // required
                      value={loanProductInterestRate}
                      placeholder="Add Loan Product Interest Rate"
                      // onChange={handleChangeLoanProductInterestRate}
                      onChange={(e) => { setIsFirstCalculateClicked(false); setLoanProductInterestRate(e.target.value) }}
                      size="small"
                      disabled={isDropdownDisabled || isDisbursed}
                      type="number"
                    />
                  </div>
                  {loanProductGroupDairy ? (
                    <div className="input-item">
                      <label>Number of Cow</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="number-cow"
                        // required
                        value={numberOfCow}
                        placeholder="Add number of cow"
                        // onChange={handleChangeNumberOfCow}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setNumberOfCow(e.target.value) }}
                        size="small"
                        type="number"
                        disabled={isDisbursed}
                      />
                    </div>
                  ) : null}
                  {loanProductGroupDairy ? (
                    <div className="input-item">
                      <label>Number of Buffalo</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="number-buffalo"
                        // required
                        value={numberOfBuffalo}
                        placeholder="Add number of buffalo"
                        // onChange={handleChangeNumberOfBuffalo}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setNumberOfBuffalo(e.target.value) }}
                        size="small"
                        type="number"
                        disabled={isDisbursed}
                      />
                    </div>
                  ) : null}
                  {loanProductGroupDairy ? (
                    <div className="input-item">
                      <label>Price of Cow</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="number-buffalo"
                        // required
                        value={priceOfCow}
                        placeholder="Add Price of Cow"
                        onChange={(e) => { setIsFirstCalculateClicked(false); setPriceOfCow(e.target.value) }}
                        size="small"
                        type="number"
                        disabled={isDisbursed}
                      />
                    </div>
                  ) : null}
                  {loanProductGroupDairy ? (
                    <div className="input-item">
                      <label>Price of Buffalo</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="number-buffalo"
                        // required
                        value={priceOfBuffalo}
                        placeholder="Add Price of buffalo"
                        onChange={(e) => { setIsFirstCalculateClicked(false); setPriceOfBuffalo(e.target.value) }}
                        size="small"
                        type="number"
                        disabled={isDisbursed}
                      />
                    </div>
                  ) : null}
                  {cattleInsuranceTitle === "INTERNAL" && loanProductGroupDairy ? (
                    <div className="input-item">
                      <label>Cattle Insurance Tenure(In Years)</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        select
                        name="loan-cattle-insurance"
                        variant="outlined"
                        value={cattleInsuranceTenure}
                        size="small"
                        onChange={(e) => { setIsFirstCalculateClicked(false); setcattleInsuranceTenure(e.target.value) }}
                        disabled={isDisbursed}
                      >
                        <MenuItem value="12">1</MenuItem>
                        <MenuItem value="24">2</MenuItem>
                        <MenuItem value="36">3</MenuItem>
                      </TextField>
                    </div>
                  ) : ("")}
                </div>
                <h3 className="heading-three">Duration</h3>
                <div className="bank-details-add-loan">
                  <div className="input-item">
                    <label>Loan Duration (In Months)</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="loan-duration"
                      value={loanDuration}
                      // required
                      // onChange={handleChangeLoanDuration}
                      onChange={(e) => { setIsFirstCalculateClicked(false); setLoanDuration(e.target.value) }}
                      placeholder="Please Add Loan Duration"
                      size="small"
                      disabled={isDropdownDisabled || isDisbursed}
                      type="number"
                    />
                  </div>
                </div>
                <h3 className="heading-three">Loan Product Principal</h3>
                <div className="bank-details-add-loan">
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Loan Principal Amount</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="principal-amount"
                        value={loanPrincipalAmount}
                        disabled
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        // onChange={handleChangeLoanPrincipalAmount}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setLoanPrincipalAmount(e.target.value) }}
                        placeholder="Principal Amount"
                        size="small"
                      />
                    </div>
                  ) : (
                    <div className="input-item">
                      <label>Loan Principal Amount</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="principal-amount"
                        value={loanPrincipalAmount}
                        // onChange={handleChangeLoanPrincipalAmount}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setLoanPrincipalAmount(e.target.value) }}
                        placeholder="Principal Amount"
                        size="small"
                        disabled={isDropdownDisabled || autoComputeLoanAmount || isDisbursed}
                        type="number"
                      />
                    </div>
                  )}
                  <div className="input-item" style={{ position: "relative" }}>
                    <label>
                      Loan Release Date{" "}
                      <span
                        style={{
                          position: "absolute",
                          top: "18px",
                          left: "0",
                          fontSize: "12px",
                          color: "grey",
                          fontWeight: "600",
                          disabled: { isDisbursed }
                        }}
                      >
                        (Repayment are generated based on Loan release date)
                      </span>
                    </label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="loan-release-date"
                      // required
                      value={
                        loanReleaseDate ? loanReleaseDate.slice(0, 10) : ""
                      }
                      // onChange={handleChangeLoanReleaseDate}
                      onChange={(e) => { setIsFirstCalculateClicked(false); setLoanReleaseDate(e.target.value) }}
                      type="date"
                      size="small"
                      disabled={isDropdownDisabled || isDisbursed}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                  </div>
                  <div className="input-item">
                    <label>Loan Tenure Start Date</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="tenure-start-date"
                      value={
                        loanTenureStartDate
                          ? loanTenureStartDate.slice(0, 10)
                          : ""
                      }
                      // onChange={handleTenureStartDate}
                      onChange={(e) => setLoanTenureStartDate(e.target.value)}
                      type="date"
                      size="small"
                      disabled
                      style={{ backgroundColor: "rgb(216,216,216" }}
                    // disabled={isDropdownDisabled || isDisbursed}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                  </div>

                  <div className="input-item">
                    <label>Loan Pre EMI Interest</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="pre-emi-interest"
                      value={loanPreEmiInterest}
                      disabled
                      onChange={(e) => { setIsFirstCalculateClicked(false); setLoanPreEmiInterest(e.target.value) }}
                      style={{ backgroundColor: "rgb(216,216,216" }}
                      placeholder="Pre EMI Interest"
                      size="small"
                    />
                  </div>
                  <div className="input-item">
                    <label>Loan EMI Start Date</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      disabled
                      type="date"
                      value={
                        loanEmiStartDate ? loanEmiStartDate.slice(0, 10) : ""
                      }
                      name="emi-start-date"
                      onChange={(e) => setLoanEmiStartDate(e.target.value)}
                      style={{ backgroundColor: "rgb(216,216,216" }}
                      placeholder="Loan EMI Start Date"
                      size="small"
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                  </div>
                  <div className="input-item">
                    <label>Loan EMI Last Date</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      type="date"
                      value={
                        loanEmiLastDate ? loanEmiLastDate.slice(0, 10) : ""
                      }
                      name="emi-last-date"
                      disabled
                      onChange={(e) => setLoanEmiLastDate(e.target.value)}
                      style={{ backgroundColor: "rgb(216,216,216" }}
                      placeholder="Loan EMI Last Date"
                      size="small"
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                  </div>
                  <div className="input-item">
                    <label>Loan Disbursed Amount</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="disbursed-amount"
                      disabled
                      value={loanDisbursedAmount}
                      onChange={(e) => setLoanDisbursedAmount(e.target.value)}
                      style={{ backgroundColor: "rgb(216,216,216" }}
                      placeholder="Loan Disbursed Amount"
                      size="small"
                    />
                  </div>
                  {loanType === "TOPUP" || state.loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label> TopUp Amount </label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        value={topUpAmount}
                        // onChange={handleChangetopUpAmount}
                        onChange={(e) => { setIsFirstCalculateClicked(false); settopUpAmount(e.target.value) }}
                        placeholder="TopUp Amount"
                        size="small"
                        disabled={isDropdownDisabled || autoComputeLoanAmount || isDisbursed}
                        type="number"
                      />
                    </div>
                  ) : ("")}
                </div>
                <div className="bank-details-add-loan mt-5">
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Pending Principal</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        disabled
                        value={pendingPrincipal}
                        onChange={(e) => setpendingPrincipal(e.target.value)}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Pending Principal"
                        size="small"
                      />
                    </div>
                  ) : ("")}
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Pending Interest</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        disabled
                        value={pendingInterest}
                        onChange={(e) => setpendingInterest(e.target.value)}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Pending Interest"
                        size="small"
                      />
                    </div>
                  ) : ("")}
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Pending Charges</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        disabled
                        value={pendingCharges}
                        onChange={(e) => setpendingCharges(e.target.value)}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Pending Charges"
                        size="small"
                      />
                    </div>
                  ) : ("")}
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Total Outstanding Amount</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        disabled
                        value={totalOutstandingAmount}
                        onChange={(e) => setTotalOutstandingAmount(e.target.value)}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Total Outstanding Amount"
                        size="small"
                      />
                    </div>
                  ) : ("")}
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Waiver</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        value={waiver}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setWaiver(e.target.value) }}
                        // style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Waiver"
                        size="small"
                        disabled={isDisbursed}
                      />
                    </div>
                  ) : ("")}
                  {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                    <div className="input-item">
                      <label>Net Outstanding Amount</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        value={netOutstandingAmount}
                        onChange={(e) => setNetOutstandingAmount(e.target.value)}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Net Outstanding Amount"
                        size="small"
                        disabled
                      />
                    </div>
                  ) : ("")}

                  <div className="input-item mt-2">
                    {loanType === "TOPUP" || loanType === "TOPUP + BT" || state.loanType === "TOPUP" || state.loanType === "TOPUP + BT" ? (
                      <Button
                        variant="contained"
                        style={{ marginRight: "1rem" }}
                        onClick={() => {
                          handleUpdateCharges();
                        }}
                        disabled={isDisbursed}
                      >
                        Fetch Latest Outstanding Amount
                      </Button>
                    ) : ("")}
                    <Button
                      variant="contained"
                      style={{ marginRight: "1rem" }}
                      onClick={() => {
                        handleCalculateLoan(1);
                        // setIsFirstCalculateClicked(true);
                      }}
                      disabled={isFirstCalculateClicked || isDisbursed}
                    >
                      Calculate Loan
                    </Button>
                  </div>
                </div>
                {/* <h3 className="heading-three">Processing Fee Calulation</h3>
                <div className="bank-details-add-loan">
                  <div className="input-item">
                    <label>PF Amount</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="loan-duration"
                      disabled
                      value={pfAmount}
                      style={{ backgroundColor: "rgb(216,216,216" }}
                      onChange={(e) => setpfAmount(e.target.value)}
                      placeholder="PF Amount"
                      size="small"
                    />
                  </div>
                  <div className="input-item">
                    <label>PF Waiver</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="loan-duration"
                      value={pfWaiver}
                      // required
                      // onChange={handleChangepfWaiver}
                      onChange={(e) => { setIsFirstCalculateClicked(false); setpfWaiver(e.target.value) }}
                      placeholder="PF Waiver"
                      size="small"
                      disabled={isDropdownDisabled || isDisbursed}
                      type="number"
                    />
                  </div>
                  <div className="input-item">
                    <label>Net PF Amount</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      variant="outlined"
                      name="disbursed-amount"
                      value={netPf}
                      onChange={(e) => setNetPf(e.target.value)}
                      style={{ backgroundColor: "rgb(216,216,216" }}
                      placeholder="Net PF Amount"
                      size="small"
                      disabled
                    />
                  </div>
                </div> */}
                <div>
                  {
                    loanfeesArray.filter(fee => fee.loanfees !== "loanfees_1").length ? (
                      <>
                        <h3 className="heading-three">Loan Fees</h3>
                        <div className="bank-details-add-loan">
                          {loanfeesArray
                            .filter(fee => fee.loanfees !== "loanfees_1")
                            .map((fee, index) => (
                              <React.Fragment key={index}>
                                <div className="input-item">
                                  <label>Loan Fees Name</label>
                                  <br />
                                  <br />
                                  <TextField
                                    className="input-field-add-loan"
                                    name={`loan-fees-name-${index}`}
                                    disabled
                                    variant="outlined"
                                    value={fee.loanfees_name || ""}
                                    size="small"
                                  // onChange={handleChange}
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Loan Fees Amount</label>
                                  <br />
                                  <br />
                                  <TextField
                                    className="input-field-add-loan"
                                    name={`loan-fees-amount-${index}`}
                                    disabled
                                    variant="outlined"
                                    value={Math.round(fee.loanfees_amount) || ""}
                                    size="small"
                                  // onChange={handleChange}
                                  />
                                </div>
                                <br />
                                <br />
                              </React.Fragment>
                            ))}
                        </div>
                      </>
                    ) : null
                  }

                  <div className="bank-details-add-loan">
                    <div className="input-item mt-6">
                      <label>PF Amount</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="loan-duration"
                        disabled
                        value={pfAmount}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        onChange={(e) => setpfAmount(e.target.value)}
                        placeholder="PF Amount"
                        size="small"
                      />
                    </div>
                    <div className="input-item mt-6">
                      <label>PF Waiver</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="loan-duration"
                        value={pfWaiver}
                        // required
                        // onChange={handleChangepfWaiver}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setpfWaiver(e.target.value) }}
                        placeholder="PF Waiver"
                        size="small"
                        disabled={isDropdownDisabled || isDisbursed}
                        type="number"
                      />
                    </div>
                    <div className="input-item mt-6">
                      <label>Net PF Amount</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        variant="outlined"
                        name="disbursed-amount"
                        value={netPf}
                        onChange={(e) => setNetPf(e.target.value)}
                        style={{ backgroundColor: "rgb(216,216,216" }}
                        placeholder="Net PF Amount"
                        size="small"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                {(loanType === "TOPUP" || state.loanType === "TOPUP") && isLIInternal ? (
                  <>
                    <h3 className="heading-three mt-2">Life Insurance Calculation</h3>
                    <div className="insurance-type">
                      <div className="input-item">
                        <input
                          type="radio"
                          value="topup_amt"
                          name="cashfree"
                          checked={insurancetypeData === "topup_amt"}
                          // onChange={(e) => handletopupAmountRadio(e)}
                          onChange={(e) => { setIsFirstCalculateClicked(false); setinsurancetypeData(e.target.value) }}
                          disabled={isDropdownDisabled || isDisbursed}
                        ></input>
                        <label>On TopUp Amount</label>
                        <br></br>
                        <br></br>
                      </div>
                      <div className="input-item">
                        <input
                          type="radio"
                          value="pri_amt"
                          name="cashfree"
                          checked={insurancetypeData === "pri_amt"}
                          onChange={(e) => { setIsFirstCalculateClicked(false); setinsurancetypeData(e.target.value) }}
                          // onChange={(e) => handleprincipalAmountRadio(e)}
                          disabled={isDropdownDisabled || isDisbursed}
                        ></input>
                        <label>On Principal Amount</label>
                        <br></br>
                      </div>
                    </div>
                  </>
                ) : ("")}

                {showLifeIns === true || showPropertyIns === true || showCattleIns === true ? (
                  <h3 className="heading-three">Insurance</h3>
                ) : (
                  ""
                )}
                <div className="bank-details-add-loan">
                  {showLifeIns === true ? (
                    <div className="menu-item-add-loan">
                      <label>Life Insurance {lifeInsuranceTitle}</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        name="loan-life-insurance"
                        variant="outlined"
                        disabled={lifeInsuranceTitle === "INTERNAL" || isDisbursed}
                        value={lifeInsuranceAmount}
                        // placeholder="Enter Life Insurance"
                        size="small"
                        // onChange={handlelifeInsuranceAmount}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setlifeInsuranceAmount(e.target.value) }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {showPropertyIns === true ? (
                    <div className="menu-item-add-loan">
                      <label>Property Insurance {propertyInsuranceTitle}</label>
                      <br />
                      <br />
                      <TextField
                        className="input-field-add-loan"
                        name="loan-property-insurance"
                        variant="outlined"
                        disabled={isDisbursed}
                        value={propertyInsuranceAmount}
                        // placeholder="Enter Loan Property Insurance"
                        size="small"
                        // onChange={handlepropertyInsuranceAmount}
                        onChange={(e) => { setIsFirstCalculateClicked(false); setpropertyInsuranceAmount(e.target.value) }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {showCattleIns === true ? (
                    <>
                      <div className="menu-item-add-loan">
                        <label>Cattle Insurance {cattleInsuranceTitle}</label>
                        <br />
                        <br />
                        <TextField
                          className="input-field-add-loan"
                          name="loan-cattle-insurance"
                          variant="outlined"
                          disabled={cattleInsuranceTitle === "INTERNAL" || isDisbursed}
                          value={cattleInsuranceAmount}
                          size="small"
                          onChange={(e) => { setIsFirstCalculateClicked(false); setcattleInsuranceAmount(e.target.value) }}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <h3 className="heading-three">Repayments</h3>
                <div className="bank-details-add-loan">
                  <div className="input-item">
                    <label>Repayment Cycle</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      // select
                      name="repayment-cycle"
                      disabled
                      variant="outlined"
                      value={"MONTHLY"}
                      size="small"
                    // onChange={handleChangeRepaymentAmount}
                    />
                  </div>
                  <div className="input-item">
                    <label>Please Mention Advance EMI If Any</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      select
                      name="mention-advance-emi"
                      variant="outlined"
                      value={advanceEmi}
                      size="small"
                      // onChange={handleChangeAdvanceEmi}
                      onChange={(e) => setAdvanceEmi(e.target.value)}
                      disabled={isDropdownDisabled || isDisbursed}
                    >
                      <MenuItem value="0">0</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                    </TextField>
                  </div>
                </div>
                <br></br>
                <Button
                  variant="contained"
                  style={{ marginRight: "1rem" }}
                  onClick={() => {
                    handleCalculateLoan(2);
                    setIsSecondCalculateClicked(true);
                  }}
                  disabled={isSecondCalculateClicked || isDisbursed}
                >
                  Calculate Loan
                </Button>
                <h3 className="heading-three">Tranche</h3>
                <div className="bank-details-add-loan">
                  <TrancheDock partlyDisbursed={partlyDisbursed} currentTrancheArray={currentTrancheArr} edit={true} setTrancheArray={handleTrancheDetails} amount={loanDisbursedAmount} prinAmount={loanPrincipalAmount} currentTrancheNumber={currentTrancheNumber} releaseDate={loanReleaseDate} setTrancheNumber={setNumberOfTranche} isDisbursed={isDisbursed} />
                </div>
                <h3 className="heading-three">Additional Information</h3>
                <div className="bank-details-add-loan">
                  <div className="input-item">
                    <label>Select Loan Purpose<span> *</span></label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      select
                      name="loan-purpose"
                      variant="outlined"
                      placeholder="Please Select Loan Purpose"
                      value={loanPurpose}
                      size="small"
                      // onChange={handleChangeLoanPurpose}
                      onChange={(e) => setLoanPurpose(e.target.value)}
                      disabled={isDropdownDisabled || isDisbursed}
                    >
                      <MenuItem value="CATTLE PURCHASE">CATTLE PURCHASE</MenuItem>
                      <MenuItem value="CATTLE SHED CONSTRUCTION">CATTLE SHED CONSTRUCTION</MenuItem>
                      <MenuItem value="CATTLE PURCHASE & SHED CONSTRUCTION">CATTLE PURCHASE & SHED CONSTRUCTION</MenuItem>
                      <MenuItem value="HOME RENOVATION">HOME RENOVATION</MenuItem>
                      <MenuItem value="HOME CONSTRUCTION">HOME CONSTRUCTION</MenuItem>
                      <MenuItem value="FAMILY FUNCTION">FAMILY FUNCTION</MenuItem>
                      <MenuItem value="EDUCATION">EDUCATION</MenuItem>
                      <MenuItem value="MEDICAL PURPOSE">MEDICAL PURPOSE</MenuItem>
                      <MenuItem value="DEBT CONSOLIDATION">DEBT CONSOLIDATION</MenuItem>
                      <MenuItem value="BUSINESS PURPOSE">BUSINESS PURPOSE</MenuItem>
                      <MenuItem value="HOME EXPANSION">HOME EXPANSION</MenuItem>
                      <MenuItem value="PURCHASE OF OTHER PROPERTY">PURCHASE OF OTHER PROPERTY</MenuItem>
                      <MenuItem value="TOP UP AND BALANCE TRANSFER">TOP UP AND BALANCE TRANSFER</MenuItem>
                    </TextField>
                  </div>
                </div>

                <h3 className="heading-three">Others (Optional)</h3>
                <div className="grid-2">
                  <div className="menu-item-add-loan-others">
                    <label>Loan Guarantors</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      // select
                      name="select-guarantors"
                      variant="outlined"
                      value={selectGuarantors}
                      placeholder="Enter Loan Guarantors"
                      size="small"
                      onChange={(e) => setSelectGuarantors(e.target.value)}
                      disabled={isDropdownDisabled || isDisbursed}
                    />
                  </div>
                </div>

                <div className="grid-2">
                  <div className="menu-item-add-loan">
                    <label>Loan Comments</label>
                    <br />
                    <br />
                    <TextField
                      className="input-field-add-loan"
                      // select
                      name="loan-comments"
                      variant="outlined"
                      value={loanComments}
                      placeholder="Loan Comments"
                      size="small"
                      onChange={(e) => setLoanComments(e.target.value)}
                      disabled={isDropdownDisabled || isDisbursed}
                    />
                  </div>
                </div>
                <div className="btns-add-borrower">
                  <Tooltip
                    title={isUpdateDisabled ? "Please click Both Calculate Loan Buttons first" : ""}
                    arrow
                  >
                    <span>
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                        disabled={isUpdateDisabled || isDisbursed}
                      >
                        Update
                      </Button>
                    </span>
                  </Tooltip>
                </div>
              </form>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}
